export default {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1400,
};
